

document.addEventListener('DOMContentLoaded', function() {
    var areaSelect = document.getElementById('area-select');
    var prefectureSelect = document.getElementById('prefecture-select');
    var shopList = document.getElementById('shop-list');

var prefecturesByArea = {
        "北海道": ["北海道"],
        "東北": ["青森", "岩手", "宮城", "秋田", "山形", "福島"],
        "関東": ["茨城", "栃木", "群馬", "埼玉", "千葉", "東京", "神奈川"],
        "中部": ["新潟", "富山", "石川", "福井", "山梨", "長野", "岐阜", "静岡", "愛知"],
        "近畿": ["三重", "滋賀", "京都", "大阪", "兵庫", "奈良", "和歌山"],
        "中国": ["鳥取", "島根", "岡山", "広島", "山口"],
        "四国": ["徳島", "香川", "愛媛", "高知"],
        "九州": ["福岡", "佐賀", "長崎", "熊本", "大分", "宮崎", "鹿児島", "沖縄"]
    };

    // 関東エリアに自動的に絞り込む処理を追加
    setDefaultAreaToKanto();

    // 初期状態で関東に設定する関数
    function setDefaultAreaToKanto() {
        var defaultArea = '関東'; // デフォルトエリアを関東に設定
        areaSelect.value = defaultArea; // 選択された地域を関東に設定
        updatePrefectureOptions(defaultArea); // 都道府県の選択肢を更新
        filterShops(defaultArea, ''); // 店舗のフィルタリングを実行
    }

    // 地域選択時のイベントリスナー
    areaSelect.addEventListener('change', function() {
        var selectedArea = this.value;
        updatePrefectureOptions(selectedArea);
        filterShops(selectedArea, '');

        if (selectedArea === '北海道') {
            prefectureSelect.value = '北海道';
            filterShops('北海道', '北海道');
        }
    });

    // 都道府県選択時のイベントリスナー
    prefectureSelect.addEventListener('change', function() {
        filterShops(areaSelect.value, this.value);
    });

    // 都道府県オプションを更新する関数
    function updatePrefectureOptions(area) {
        prefectureSelect.innerHTML = '<option value="">選択してください</option>';
        if (prefecturesByArea[area]) {
            prefecturesByArea[area].forEach(function(prefecture) {
                var option = document.createElement('option');
                option.value = prefecture;
                option.textContent = prefecture;
                prefectureSelect.appendChild(option);
            });
        }
    }

    // 店舗をフィルタリングする関数
    function filterShops(area, prefecture) {
        var shops = shopList.getElementsByClassName('shop_info');
        Array.from(shops).forEach(function(shop) {
            var shopArea = shop.getAttribute('data-area');
            var shopPrefecture = shop.getAttribute('data-prefecture');
            if ((area === '' || shopArea === area) && (prefecture === '' || shopPrefecture === prefecture)) {
                shop.style.display = '';
            } else {
                shop.style.display = 'none';
            }
        });
    }

    // 店舗を地域・都道府県別にソートする関数
    function sortShopsByRegion() {
        var areasOrder = ["北海道", "東北", "関東", "中部", "近畿", "中国", "四国", "九州"];
        var sortedShops = [];
    
        areasOrder.forEach(function(area) {
            var prefectures = prefecturesByArea[area];
            if (prefectures) {
                prefectures.forEach(function(prefecture) {
                    Array.from(shopList.getElementsByClassName('shop_info')).forEach(function(shop) {
                        if (shop.getAttribute('data-area') === area && shop.getAttribute('data-prefecture') === prefecture) {
                            sortedShops.push(shop);
                        }
                    });
                });
            }
        });
    
        if (sortedShops.length === 0) {
            // ソートされた店舗がない場合、全ての店舗を表示
            Array.from(shopList.getElementsByClassName('shop_info')).forEach(function(shop) {
                sortedShops.push(shop);
            });
        }
    
        while (shopList.firstChild) {
            shopList.removeChild(shopList.firstChild);
        }
    
        sortedShops.forEach(function(shop) {
            shopList.appendChild(shop);
        });
    }


    // 初期状態では店舗を地域別、そして県別にソートして表示
    sortShopsByRegion();

    // リンクが空の場合、クリックイベントを無効化し、マウスカーソルをデフォルトに変更する関数
    function disableEmptyLinks() {
        var shopLinks = document.querySelectorAll('.shop_info a');
        shopLinks.forEach(function(link) {
            if (!link.getAttribute('href') || link.getAttribute('href').trim() === '') {
                link.addEventListener('click', function(event) {
                    event.preventDefault();
                });
                link.style.cursor = 'default';
                link.style.borderBottom = 'none';
            } else {
                link.style.color = '#286bd6'; // リンクが存在する場合の色を設定
            }
        });
    }

    disableEmptyLinks();
});